(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eden-collection-filters"] && !Shopify.designMode) return;
  try {
    (function(){
    var HIDE=['package-type','certifications','serum-target-areas'];
    function relabel(){
      var btn=document.querySelector('.collection__filters__toggle');
      if(!btn)return;
      if(!btn.querySelector('.eden-ft__label')){
        var l=document.createElement('span');
        l.className='eden-ft__label';
        l.textContent='Filter & sort';
        btn.appendChild(l);
        var s=document.createElement('span');
        s.className='eden-ft__count';
        btn.appendChild(s);
        btn.classList.add('eden-ft');
      }
      var native=document.querySelector('.collection__products-count');
      var countText=native?native.textContent.trim():'';
      var cs=btn.querySelector('.eden-ft__count');
      if(cs.textContent!==countText)cs.textContent=countText;
      btn.setAttribute('aria-label',countText?'Filter and sort, '+countText:'Filter and sort');
    }
    function prune(){
      document.querySelectorAll('.collection__filter').forEach(function(f){
        var t=f.querySelector('.collection__filter__title');
        if(!t)return;
        var id=(t.getAttribute('aria-controls')||'').replace('CollectionFilter--','');
        var hide=HIDE.indexOf(id)>-1;
        if(!hide&&!f.querySelector('.filter__price')){
          var opts=f.querySelectorAll('.filter__input');
          var live=0;
          opts.forEach(function(i){if(!i.disabled||i.checked)live++});
          if(opts.length&&live<=1&&t.getAttribute('data-filter-active')!=='true')hide=true;
        }
        f.classList.toggle('eden-ft-hidden',hide);
      });
    }
    function sinkSoldOut(){
      document.querySelectorAll('[id$="__main"] .grid').forEach(function(g){
        var cards=[].slice.call(g.children).filter(function(c){return c.classList.contains('product-grid-item')});
        var seenSold=false,needed=false;
        cards.forEach(function(c){
          if(c.classList.contains('soldout'))seenSold=true;
          else if(seenSold)needed=true;
        });
        if(!needed)return;
        cards.forEach(function(c){if(c.classList.contains('soldout'))g.appendChild(c)});
      });
    }
    function rangeButtons(){
      document.querySelectorAll('[id*="section_list_butttons"]').forEach(function(sec){
        if(!sec.getAttribute('data-eden-rb')){
          sec.setAttribute('data-eden-rb','1');
          var labels=[].map.call(sec.querySelectorAll('.list-collections__item__outer'),function(a){
            var leaves=[].filter.call(a.querySelectorAll('*'),function(e){return !e.children.length&&e.textContent.trim()});
            return leaves[leaves.length-1];
          });
          var counts={};
          labels.forEach(function(t){if(t){var w=t.textContent.trim().split(/\s+/)[0].toUpperCase();counts[w]=(counts[w]||0)+1}});
          var top=Object.keys(counts).sort(function(a,b){return counts[b]-counts[a]})[0];
          if(top&&counts[top]>=3&&counts[top]>=labels.length/2){
            labels.forEach(function(t){
              if(!t)return;
              var p=t.textContent.trim().split(/\s+/);
              if(p.length>1&&p[0].toUpperCase()===top)t.textContent=p.slice(1).join(' ');
            });
          }
          var track=sec.querySelector('.carousel--mobile');
          if(track){
            var check=function(){track.classList.toggle('eden-rb-end',track.scrollLeft+track.clientWidth>=track.scrollWidth-4)};
            track.addEventListener('scroll',check,{passive:true});
            window.addEventListener('resize',check);
            check();
          }
        }
      });
    }
    function run(){relabel();prune();sinkSoldOut();rangeButtons()}
    function init(){
      run();
      var busy=false;
      new MutationObserver(function(){
        if(busy)return;
        busy=true;
        requestAnimationFrame(function(){run();busy=false});
      }).observe(document.body,{childList:true,subtree:true});
    }
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eden-search"] && !Shopify.designMode) return;
  try {
    (function(){
  var root=document.getElementById('eden-search');
  if(!root||root.dataset.ready)return;
  root.dataset.ready='1';
  var input=root.querySelector('.es__input');
  var clearBtn=root.querySelector('[data-es-clear]');
  var trending=root.querySelector('[data-es-trending]');
  var results=root.querySelector('[data-es-results]');
  var empty=root.querySelector('[data-es-empty]');
  var title=root.querySelector('[data-es-title]');
  var allLink=root.querySelector('[data-es-all]');
  var popular=root.querySelector('[data-es-popular]');
  var sugg=root.querySelector('[data-es-sugg]');
  var queries=root.querySelector('[data-es-queries]');
  var cols=root.querySelector('[data-es-cols]');
  var colList=root.querySelector('[data-es-collections]');
  var recent=root.querySelector('[data-es-recent]');
  var recentList=root.querySelector('[data-es-recent-list]');
  var RKEY='eden_recent_searches';
  var clockIcon='<svg class="es__ti" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 7.5V12l3 2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var pushed=false;
  var more=document.createElement('a');
  more.className='es__more';more.hidden=true;
  results.parentNode.appendChild(more);
  var searchUrl=root.querySelector('.es__bar').getAttribute('action');
  var timer=null,seq=0,lastFocus=null;
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function fullUrl(q){return searchUrl+'?q='+encodeURIComponent(q)+'&type=product&options%5Bprefix%5D=last';}
  function hi(text,q){var t=esc(text),w=esc(q).trim();if(!w)return t;var i=t.toLowerCase().indexOf(w.toLowerCase());return i<0?t:t.slice(0,i)+'<mark>'+t.slice(i,i+w.length)+'</mark>'+t.slice(i+w.length);}
  function getRecent(){try{var l=JSON.parse(localStorage.getItem(RKEY));return Array.isArray(l)?l:[];}catch(e){return [];}}
  function saveRecent(q){
    q=String(q||'').trim();
    if(q.length<2)return;
    var l=getRecent().filter(function(x){return String(x).toLowerCase()!==q.toLowerCase();});
    l.unshift(q);
    try{localStorage.setItem(RKEY,JSON.stringify(l.slice(0,3)));}catch(e){}
  }
  function renderRecent(){
    var l=getRecent();
    recentList.innerHTML=l.map(function(x){return '<a href="'+esc(fullUrl(x))+'">'+clockIcon+esc(x)+'</a>';}).join('');
    recent.hidden=!l.length;
  }
  function open(){
    if(!root.hidden)return;
    lastFocus=document.activeElement;
    if(!input.value.trim())renderRecent();
    try{history.pushState({edenSearch:1},'');pushed=true;}catch(e){pushed=false;}
    root.hidden=false;
    document.documentElement.classList.add('es-open');
    setTimeout(function(){input.focus();},30);
  }
  function close(fromHistory){
    if(root.hidden)return;
    root.hidden=true;
    if(pushed&&!fromHistory){pushed=false;try{history.back();}catch(e){}}
    pushed=false;
    document.documentElement.classList.remove('es-open');
    if(lastFocus&&lastFocus.focus){try{lastFocus.focus();}catch(e){}}
  }
  function idle(){
    title.textContent='Trending this week';
    trending.hidden=false;results.hidden=true;empty.hidden=true;allLink.hidden=true;more.hidden=true;
    popular.hidden=false;sugg.hidden=true;cols.hidden=true;clearBtn.hidden=true;
    renderRecent();
  }
  function card(p){
    return '<a class="es__card" href="'+esc(p.u)+'"><span class="es__img">'+(p.i?'<img src="'+esc(p.i)+'" alt="'+esc(p.t)+'" width="72" height="72" loading="lazy">':'')+'</span><span class="es__info"><span class="es__v">'+esc(p.v)+'</span><span class="es__t">'+esc(p.t)+'</span><span class="es__p">'+esc(p.p)+(p.c?' <s>'+esc(p.c)+'</s>':'')+'</span>'+(p.a?'<span class="es__b">'+(p.b||'')+'</span>':'<span class="es__so">Sold out</span>')+'</span></a>';
  }
  function run(q){
    var my=++seq;
    var pr=fetch(searchUrl+'?q='+encodeURIComponent(q)+'&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&view=eden-json').then(function(r){return r.json();});
    var sg=fetch(searchUrl+'/suggest.json?q='+encodeURIComponent(q)+'&resources%5Btype%5D=query,collection&resources%5Blimit%5D=6').then(function(r){return r.json();}).catch(function(){return null;});
    Promise.all([pr,sg]).then(function(d){
      if(my!==seq)return;
      var res=d[0]||{products:[],count:0},s=d[1]&&d[1].resources&&d[1].resources.results||{};
      var qs=(s.queries||[]).filter(function(x){return x.text.toLowerCase()!==q.toLowerCase();}).slice(0,5);
      var cs=(s.collections||[]).slice(0,5);
      queries.innerHTML=qs.map(function(x){return '<a href="'+esc(fullUrl(x.text))+'">'+hi(x.text,q)+'</a>';}).join('');
      colList.innerHTML=cs.map(function(c){return '<a href="'+esc(c.url)+'">'+hi(c.title,q)+'</a>';}).join('');
      sugg.hidden=!qs.length;cols.hidden=!cs.length;popular.hidden=!!(qs.length||cs.length);recent.hidden=true;
      var list=res.products.slice(0,8);
      if(list.length){
        title.textContent='Products';
        results.innerHTML=list.map(card).join('');
        results.hidden=false;trending.hidden=true;empty.hidden=true;
        allLink.href=fullUrl(q);allLink.textContent='See all';allLink.hidden=false;
        more.href=fullUrl(q);more.textContent='See all results for “'+q+'”';more.hidden=false;
      }else{
        empty.textContent='No results for “'+q+'”. Try a brand or a skin concern, or browse what’s trending.';
        empty.hidden=false;results.hidden=true;trending.hidden=false;title.textContent='Trending this week';allLink.hidden=true;more.hidden=true;popular.hidden=false;
      }
    }).catch(function(){});
  }
  input.addEventListener('input',function(){
    var q=input.value.trim();
    clearBtn.hidden=!input.value;
    clearTimeout(timer);
    if(q.length<2){seq++;idle();return;}
    timer=setTimeout(function(){run(q);},220);
  });
  clearBtn.addEventListener('click',function(){input.value='';seq++;idle();input.focus();});
  root.querySelector('.es__bar').addEventListener('submit',function(e){
    e.preventDefault();
    var q=input.value.trim();
    if(q){saveRecent(q);pushed=false;window.location.href=fullUrl(q);}
  });
  root.addEventListener('click',function(e){
    if(e.target.closest('[data-es-close]')){close();return;}
    if(e.target.closest('[data-es-recent-clear]')){try{localStorage.removeItem(RKEY);}catch(x){}renderRecent();return;}
    var a=e.target.closest('a[href]');
    if(a){
      var q=input.value.trim();
      if(q.length>=2)saveRecent(q);
      else if(a.closest('[data-es-recent-list],[data-es-popular]'))saveRecent(a.textContent);
      pushed=false;
    }
  });
  window.addEventListener('popstate',function(){if(!root.hidden)close(true);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  var triggers='.search-popdown__toggle,[data-nav-search-open],[data-es-open],a[href="/search"],a[href="'+searchUrl+'"]';
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest(triggers);
    if(!t||root.contains(t))return;
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    var d=t.closest('details');if(d)d.removeAttribute('open');
    open();
  },true);
  document.addEventListener('focusin',function(e){
    var f=e.target;
    if(f&&f.matches&&f.matches('input[name="q"]')&&!root.contains(f)&&!document.body.classList.contains('template-search')&&!f.closest('main form')){f.blur();open();}
  },true);
})();
  } catch(e) { console.error(e); }
})();

})();
